import React, {FC} from "react"
import styled from "styled-components"

import Card, {CardProps} from "./Card"
import WaveBackground from "./WaveBackground"

const BackgroundImage = styled.div`
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 0;
`

interface StyledCardProps {
  backgroundColor: string
}

const StyledCard = styled(Card)<StyledCardProps>`
  background-color: ${(props) => props.backgroundColor};
  position: relative;
`

export interface SvgCardProps extends CardProps {
  color: string
}

const SvgCard: FC<SvgCardProps> = ({children, color, ...other}) => {
  return (
    <StyledCard flush backgroundColor={color} {...other}>
      <BackgroundImage>
        <WaveBackground color={color} />
      </BackgroundImage>
      {children}
    </StyledCard>
  )
}

export default SvgCard
